import { CurrentUser } from '../../../models/CurrentUser'

export default function allowedUserRoles(currentUser: CurrentUser | undefined) {
  if (!currentUser) {
    return []
  }

  return {
    trainer: currentUser.permissions.user_create_user,
    user: currentUser.permissions.user_create_user,
    advanced_user: false, // Advanced users are deprecated
    admin: currentUser.permissions.user_create_admin,
    auditor: false, // NM-438: Auditor role is not supported for the moment
    customer_success_manager: currentUser.permissions.user_create_csm,
  }
}
